@if (!baseCard) {
  <a
    [routerLink]="productUrl"
    [class.discount]="product.splash && product.originalPrice !== product.price"
    [class.quick-purchase]="product.hasModules && product.quickCompositePurchase"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}
@if (baseCard) {
  <a
    href="#"
    [class.discount]="product.splash && product.originalPrice !== product.price"
    [class.quick-purchase]="product.hasModules && product.quickCompositePurchase"
    (click)="baseCard ? openProductDialog($event) : null"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

<ng-template #content>
  @if (!product.productDeliveryLimit?.hidden && product.productDeliveryLimit; as deliveryLimit) {
    <div class="delivery-limit badge">
      {{ deliveryLimit.label }}
    </div>
  }
  @if (product.badgeUrl; as badgeUrl) {
    <img class="product-card-badge badge" [src]="badgeUrl | cms: 75 : 80" alt="badge" />
  }
  @if (savings) {
    <app-savings [savings]="savings" class="badge"></app-savings>
  }
  <div class="product-card-image-container" [class.sold-out]="!product.forSale && product.notForSaleLabel">
    @defer (on viewport({ rootMargin: "50px", threshold: 0.3 })) {
      <img
        [ngSrc]="product?.primaryImageUrl || 'assets/placeholder.png'"
        [width]="imageWidth"
        [height]="imageHeight"
        [loaderParams]="{ autorotate: true, quality: 80 }"
        loading="lazy"
        [alt]="product.productDisplayName"
      />
    } @placeholder {
      <img src="assets/placeholder.png" [width]="big ? 266 : 192" [height]="big ? 204 : 130" [alt]="product.productDisplayName" />
    }

    @if (!product.forSale && product.notForSaleLabel) {
      <div class="not-for-sale">{{ product.notForSaleLabel }}</div>
    }
    @if (primaryTag && primaryTag.showFrontend === true) {
      <span class="primary-tag" [ngStyle]="{ 'background-color': primaryTag.color }">
        @if (primaryTag.icon) {
          <mat-icon class="primary-tag-icon">{{ primaryTag.icon }}</mat-icon>
        }
        <span>{{ primaryTag.name }}</span>
      </span>
    }
  </div>
  <b class="product-card-name">{{ product.productDisplayName }}</b>
  @if (!product.productCardDescription) {
    <span class="product-card-summary">
      {{ summaryLabel }}
    </span>
  } @else {
    <div [innerHTML]="product.productCardDescription | sanitizeHtml" class="rich-text"></div>
  }
  @if (!product.altPriceText) {
    <app-price [value]="price" class="price-text"></app-price>
  }
  @if (product.altPriceText) {
    <span class="price-text" [class.small]="smallAltText">{{ product.altPriceText }}</span>
  }
  @if (product.splash && product.originalPrice !== product.price) {
    <span class="product-card-original-price"> {{ originalPriceLabel }} {{ product.originalPrice | number: '.2-2' : locale }} </span>
  }
</ng-template>

@defer (hydrate on viewport) {
  @if (!baseCard) {
    <div class="buttons">
      @if (!product.hasModules && !product.isAdvertisement) {
        @let entry = isProductLine((basketProducts$ | async)[product.id]);
        @if (!entry) {
          <app-text-button [class.basket-icon]="showBasketIcon" (click)="addToBasket()" [disabled]="product.forSale === false">
            @if (showBasketIcon) {
              <mat-icon [svgIcon]="basketIcon"></mat-icon>
            }
            {{ showBasketIcon ? '' : addToBasketLabel }}
          </app-text-button>
        }
        @if (entry) {
          <app-counter
            [count]="entry.quantity"
            [minCount]="product.minCount"
            [packageOptions]="product.packageOptions"
            (add)="addProduct($event.quantity, $event.packageOptions)"
            (remove)="removeProduct(entry.quantity, $event.quantity, $event.packageOptions)"
          ></app-counter>
        }
      }
      @if (product.hasModules && product.quickCompositePurchase && !product.isAdvertisement) {
        @let entry = isInnerLineMap((basketProducts$ | async)[product.id]);
        @if (!entry) {
          <app-text-button
            [class.basket-icon]="showBasketIcon"
            (click)="addToBasket(true, entry?.lineId)"
            [disabled]="product.forSale === false"
          >
            @if (showBasketIcon) {
              <mat-icon [svgIcon]="basketIcon"></mat-icon>
            }
            {{ showBasketIcon ? '' : addToBasketLabel }}
          </app-text-button>
        }
        @if (entry) {
          <app-counter
            [count]="entry.quantity"
            [minCount]="product.minCount"
            [packageOptions]="product.packageOptions"
            (add)="addCompositeProduct($event.quantity, entry?.lineId, $event.packageOptions)"
            (remove)="removeCompositeProduct(entry.quantity, $event.quantity, entry?.lineId, $event.packageOptions)"
          ></app-counter>
        }
      }
      @if (product.hasModules && !product.isAdvertisement) {
        <app-text-button [routerLink]="productUrl" [disabled]="product.forSale === false">
          {{ chooseVariationLabel }}
        </app-text-button>
      }
      @if (product.isAdvertisement) {
        <app-text-button [routerLink]="productUrl" [disabled]="product.forSale === false">
          {{ advertisementLabel }}
        </app-text-button>
      }
    </div>
  }

  @if (baseCard) {
    <div class="buttons">
      @let quantityValue = quantity();
      @let pickedValue = picked();
      @if (!quantityValue && !pickedValue) {
        <app-text-button [disabled]="locked" (click)="add.emit(product.minCount || 1)">{{ selectLabel }}</app-text-button>
      }
      @if (!quantityValue && pickedValue) {
        <div class="picked-button">
          <app-text-button>{{ selectedLabel }} <mat-icon class="meny-selected-icon" svgIcon="tick"></mat-icon></app-text-button>
          <app-icon-button
            class="clear-selected"
            [icon]="clearSelectionIcon"
            [disabled]="locked"
            [border]="false"
            (click)="remove.emit()"
          ></app-icon-button>
        </div>
      }
      @if (quantityValue) {
        <app-counter
          [count]="quantityValue"
          [minCount]="product.minCount"
          [lockAdd]="locked"
          [lockRemove]="locked"
          (add)="add.emit($event.quantity)"
          (remove)="remove.emit($event.quantity)"
        ></app-counter>
      }
    </div>
  }
}
